/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-uploading-dialog',
  templateUrl: './uploading-dialog.component.html'
})
export class UploadingDialogComponent {
  
  mId = 'uploadingDialog';
  
  
  show(): void {
    console.log("show()");
    $(`#${this.mId}`).modal("show");
  }
  
  hide(): void {
    console.log("hide()");
    $(`#${this.mId}`).modal("hide");
  }
  
}
